// Styles
import { BrokerLandingSustainabilityHubWrapper } from './BrokerLandingSustainabilityHub.styles';

// Components
import { ButtonPrimary } from '../../../common/components';

type BrokerLandingSustainabilityHubProps = {};

const defaultProps = {};

export const BrokerLandingSustainabilityHub = (props: BrokerLandingSustainabilityHubProps) => {
  const title = 'Sustainability Hub';
  const description = 'Valuable insights and practical advice to support your organisation’s journey to net zero.';
  const imageSrc =
    'https://images.ctfassets.net/jl0e441lxc8n/7bKW28htNjvm5TLuJf15mR/92b4ac16f2f4d442e3410cdfb8345e43/SustainabilityHub_Image.jpg?w=700&q=70&fm=webp';
  const btnText = 'Sustainability Hub';
  const btnLink = `${process.env.REACT_APP_SUSTAINABILITYHUB_URL}`;
  const icon = 'menuSustainabilityHub';

  return (
    <BrokerLandingSustainabilityHubWrapper {...props}>
      <div className='brokerLandingPageSustainabilityHub'>
        <div className='container'>
          <div className='left'>
            <img alt={title} className='pr-4' src={imageSrc} width='105%' />
          </div>
          <div className='right'>
            <h4 className='mt-0 font-weight-bold' style={{ textDecoration: 'underline' }}>
              {title}
            </h4>
            <p className='pt-2'>{description}</p>
            <div className='d-flex justify-content-end pt-4 mb-1'>
              <ButtonPrimary href={btnLink} target='_blank' className='mt-auto mb-auto' icon={icon}>
                {btnText}
              </ButtonPrimary>
            </div>
          </div>
        </div>
      </div>

      <div className='brokerLandingPageSustainabilityHubMobile'>
        <h5 className='font-weight-bold' style={{ textDecoration: 'underline' }}>
          {title}
        </h5>
        <p className='pt-2'>{description}</p>
        <img alt={title} className='pr-4' src={imageSrc} width='105%' />
        <div className='d-flex justify-content-end'>
          <ButtonPrimary href={btnLink} target='_blank' className='mt-3 mb-auto' icon={icon}>
            {btnText}
          </ButtonPrimary>
        </div>
      </div>
    </BrokerLandingSustainabilityHubWrapper>
  );
};

BrokerLandingSustainabilityHub.defaultProps = defaultProps;
